import React from "react";
import classNames from "classnames";

import {API} from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Card, CardContent} from "@material-ui/core";
import moment from "moment";
import LocationCards from '../Parts/AdminLocationCard';

export default class Financials extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Stripe_Subscriptions_All._name, API.RequestType.READ_ALL);
		super(props, model);
		// this.state.limit = 16;
		// this.loadProductCount().then();
		this.loadModules().then();
		this.loadSubscriptions().then();
		this.loadSubscriptionCount().then();
		this.loadUpgrades().then();
		this.tableRef = React.createRef();
		this.state.loading = false;
		this.state.subscriptionCounts = []; // Initialize subscription counts array
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	loadModules = async () => {
		let moduleModel = new API.BuildClass(Types.Admins_Modules._name, API.RequestType.READ_ALL);
		moduleModel.limit = 25;
		let modules = await moduleModel.submit(null, API.RequestType.READ_ALL);
		console.log('modules', modules);
		this.setState({modules: modules.items})
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	loadProductCount = async () => {
		console.log('TRY TO LOAD PRODUCTS')
		let pModel = new API.BuildClass(Types.Admins_Stripe._name, 'GET_ADMIN_PRODUCT_COUNT')
		let result = await pModel.submit(null, 'GET_ADMIN_PRODUCT_COUNT');
		console.log('result products');
	}

	loadUpgrades = async () => {
		let uModel = new API.BuildClass(Types.Upgrades._name, 'GET_ADMIN');
		let result = await uModel.submit(null, 'GET_ADMIN');
		this.setState({upgrades: result.items});
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	loadSubscriptions = async () => {
		let subscriptionsModel = new API.BuildClass(Types.Subscriptions._name, API.RequestType.READ_ALL);
		subscriptionsModel.limit = 50;
		let result = await subscriptionsModel.submit(null, API.RequestType.READ_ALL);
		console.log('result subscriptions', result);
		this.setState({subscriptions: result.items})
	}

	/**
	 *
	 * @returns {Promise<void>}
	 */
	loadSubscriptionCount = async () => {
		let subscriptionCountModel = new API.BuildClass(Types.Admins_Stripe._name, 'GET_SUBSCRIPTION_COUNT_GROUPED');
		let result = await subscriptionCountModel.submit(null, 'GET_SUBSCRIPTION_COUNT_GROUPED');
		console.log('result count', result);
		this.setState({ subscriptionCounts: result.items});

	}

	/**
	 *
	 * @param module
	 * @returns {Promise<void>}
	 */
	loadModuleTable = async (module) => {
		console.log('in table', this, module);
		let mTableModel = new API.BuildClass(Types.Stripe_Subscriptions_All._name, 'GET_MODULE_TABLE');
		mTableModel.filter = {'module_plan': module.plan ?? module.id};
		let result = await mTableModel.submit(null, 'GET_MODULE_TABLE');
		this.setState({total_amount: result.total_amount, data: result.items}, () => {
			// After state is updated and component is re-rendered, scroll to the table
			if (this.tableRef && this.tableRef.current) {
				// Scroll to the table with smooth animation
				const tablePosition = this.tableRef.current.getBoundingClientRect().top;
				const scrollPosition = window.pageYOffset + tablePosition;

				// Scroll to a position slightly above the table (50px offset)
				window.scrollTo({
					top: scrollPosition - 70,
					behavior: 'smooth'
				});
			}
		});
		console.log('state', this.state);
	}

	/**
	 *
	 * @param state
	 * @returns {Promise<void>}
	 */
	fetchData = async (state) => {
		await this.fetchDataActual(state, ['total_amount']);
	}

	/**
	 *
	 * @returns {JSX.Element}
	 */
	renderTotalAmount = () => {
		const { total_amount } = this.state;
		return (
			<div style={{ display: 'flex', alignItems: 'center', marginLeft: '1rem', marginRight: '1rem' }}>
				<div style={{ fontWeight: 'bold', marginRight: '0.5rem' }}>Total MRR:</div>
				<div className="badge badge-success" style={{ padding: '0.5rem', fontSize: '1rem' }}>
					<span dangerouslySetInnerHTML={{ __html: '$' }} />
					{total_amount || '0.00'}
				</div>
			</div>
		);
	}

	renderCurrentPageTotal = () => {
		const { data } = this.state;

		// Calculate total from currently displayed subscriptions, excluding cancelled ones
		let calculatedTotal = 0;
		if (data && data.length > 0) {
			calculatedTotal = data.reduce((sum, item) => {
				// Skip if the subscription status is cancelled
				if (item.status === 'canceled') {
					return sum;
				}

				// Use plan_amount directly instead of parsing JSON
				let amount = 0;
				if (item.plan_amount) {
					// Convert string to number
					amount = parseFloat(item.plan_amount) || 0;
				}
				return sum + amount;
			}, 0);
		}

		// Format the calculated total to display as dollars
		const formattedTotal = (calculatedTotal / 100).toFixed(2);
		const displayTotal = formattedTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		return (
			<div style={{ display: 'flex', alignItems: 'center', marginLeft: '1rem', marginRight: '1rem' }}>
				<div style={{ fontWeight: 'bold', marginRight: '0.5rem' }}>Page Total MRR:</div>
				<div className="badge badge-info" style={{ padding: '0.5rem', fontSize: '1rem' }}>
					<span dangerouslySetInnerHTML={{ __html: '$' }} />
					{displayTotal || '0.00'}
				</div>
			</div>
		);
	}

	// Function to get row props based on the row's data
	getRowProps = (state, rowInfo) => {
		if (rowInfo && rowInfo.original) {
			// Set background color based on subscription status
			let backgroundColor = 'inherit';

			// Check status and apply appropriate color
			switch(rowInfo.original.status) {
				case 'canceled':
					backgroundColor = '#ffcccc'; // Light red
					break;
				case 'active':
					backgroundColor = '#ccffcc'; // Light green
					break;
				case 'trialing':
					backgroundColor = '#ffffcc'; // Light yellow
					break;
				default:
					backgroundColor = 'inherit';
			}

			return {
				style: {
					background: backgroundColor
				}
			};
		}
		return {};
	}

	render() {
		console.log('this in render', this)
		const {data, pages, limit, loading, modules, total_amount, subscriptions, subscriptionCounts, upgrades} = this.state;
		const columns = [
			{
				Header: "Account",
				id: "account",
				width: 100,
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.account_number ? obj.account_number : null
			},
			{
				Header: "Email",
				id: "email",
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.account_email ? obj.account_email : null
			},
			{
				Header: "Location",
				id: "location",
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.location_name ?? ''
			},
			{
				Header: "Subscription",
				id: "subscription",
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.module_display_name ?? obj.subscription_display_name ?? obj.upgrades_display_name
			},
			{
				Header: "Current Period Start",
				width: 150,
				id: "current_period_start",
				accessor: obj => {
					return obj.current_period_start ? moment(obj.current_period_start).local().format("MM/DD/YYYY h:mm A") : '-'
				}
			},
			{
				Header: "Current Period End",
				width: 150,
				id: "current_period_end",
				accessor: obj => {
					return obj.current_period_end ? moment(obj.current_period_end).local().format("MM/DD/YYYY h:mm A") : '-'
				}
			},
			{
				Header: "Created",
				width: 150,
				id: "created",
				accessor: obj => {
					return obj.subscription_created_date ? moment(obj.subscription_created_date).local().format("MM/DD/YYYY h:mm A") : '-'
				}
			},
			{
				Header: "Ended",
				width: 150,
				id: "ended",
				accessor: obj => {
					return obj.subscription_ended_date ? moment(obj.subscription_ended_date).local().format("MM/DD/YYYY h:mm A") : '-'
				}
			},

			{
				Header: "Status",
				id: "status",
				width: 125,
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.status ?? ''
			},
			{
				Header: "Stripe ID",
				id: "stripe_id",
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => obj.stripe_id ?? ''
			},
			{
				Header: "Monthly Recurring Revenue",
				id: "monthly_recurring_revenue",
				/** @param {Stripe_Subscriptions_All} obj */
				accessor: obj => Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format((JSON.parse(obj.plan)['amount']) / 100)?? ''
			},

		]
		return (
			<div>
				<div className={"row"}>
					<div className={"col-md"}>
						<h4>Location Modules</h4>

						<div className="form-group">
							{modules?.length > 0 ? <LocationCards
								name="Testing"
								description="Description"
								modules={modules}
								loadModuleTable={this.loadModuleTable}
								isLocModule={true}
								subscriptionCounts={subscriptionCounts} // Pass subscription counts
							/> : null}
						</div>
						<h4>Upgrades</h4>
						<div className="form-group">
							{upgrades?.length > 0 ? <LocationCards
								name="Testing"
								description="Description"
								modules={upgrades}
								loadModuleTable={this.loadModuleTable}
								isLocModule={true}
								subscriptionCounts={subscriptionCounts} // Pass subscription counts
							/> : null}
						</div>

						<h4>Account Subscriptions</h4>

						<div className="form-group">
							{subscriptions?.length > 0 ? <LocationCards
								name="Testing"
								description="Description"
								modules={subscriptions}
								loadModuleTable={this.loadModuleTable}
								isLocModule={false}
								subscriptionCounts={subscriptionCounts} // Pass subscription counts
							/> : null}
						</div>

					</div>
				</div>
				<div className={"row"}>
					<div className={"col-md"}>
						<h4>Modules / Add-ons</h4>
						<div className="form-group">
						</div>
					</div>
				</div>

				<Card ref={this.tableRef}>
					<CardContent>
						<div className="box-body">
							<div className="table-bar">
								<div className="d-flex">
									{this.renderSearch('Financials')}
									{this.renderTotalAmount()}
									{this.renderCurrentPageTotal()}
									<Button
										style={{marginLeft: '400px'}}
										color={"primary"}
										onClick={this.loadProductCount}
									>Refresh Stripe Info</Button>
									{this.renderHeaderRight("Financials", columns)}
								</div>
							</div>
							<ReactTable
								key={this.state.key}
								columns={columns}
								manual // Forces table not to paginate or sort automatically, so we can handle it server-side
								data={data}
								pages={pages} // Display the total number of pages
								loading={loading} // Display the loading overlay when we need it
								loadingText="Requesting Data"
								onFetchData={this.fetchData} // Request new data when things change
								// onFetchData={() => this.fetchDataActual(null, ['total_amount'])}
								expanderDefaults={{
									sortable: true,
									resizable: true,
									filterable: false,
									width: undefined
								}}
								onExpandedChange={this.onExpandedChange}
								defaultSorted={[
									{
										id: this.model.sort,
										desc: this.model.order === 'desc'
									}
								]}
								showPagination={pages > 1}
								defaultPageSize={limit}
								className="-striped -highlight"
								getTrProps={this.getRowProps}
							/>
						</div>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}